import { InjectionKey, Ref } from 'vue'
import { Site } from '../sites/models/site'

export const currentSiteKey = Symbol('current_site') as InjectionKey<Ref<Site>>